module.exports = __webpack_public_path__ + "static/media/Logo.020335d4.png";